<template>
  <tab-layout :full-width="true">
    <div slot="tabContent" class="bg-white rounded mb-4 p-3">
      <div class="wrap-drafts">

        <h3>Judge: {{ judge }}</h3>
        <h2 class="drafts__title">Results of {{ eventName }} ({{ activeRoundLabel }})</h2>

        <div class="draws-table draws-event">
          <table cellpadding="0" cellspacing="0">
            <thead>
              <tr>
                <th>#</th>
                <th>Rider</th>
                <th>Horse</th>
                <th>Owner</th>
                <th>Score</th>
              </tr>
            </thead>
            <tbody>
              <tr class="spacer"><td></td></tr>
              <tr
                v-for="row in results"
                :key="row.id"
              >
                <td>{{ row.place }}</td>
                <td>{{ row.competitorName }}</td>
                <td>{{ row.horseName }}</td>
                <td>{{ row.ownerName }}</td>
                <td>{{ row.score }}</td>
              </tr>
            </tbody>
          </table>

          <div class="submit">
            <a
              href="#"
              class="btn-default"
              @click.prevent="goBack"
            >Back to Draws</a>
          </div>
        </div>

        <h2 class="drafts__title">Highest Cutouts</h2>
        <div class="draws-table draws-event">
          <table cellpadding="0" cellspacing="0">
            <thead>
              <tr>
                <th>Rider</th>
                <th>Horse</th>
                <th>Cutout</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr class="spacer"><td></td></tr>
              <tr
                v-for="c in topCutout"
                :key="c.id"
              >
                <td>{{ c.rider }}</td>
                <td>{{ c.horse }}</td>
                <td>{{ c.cutout }}</td>
                <td>
                  <template v-if="hasWinner">
                    <span v-if="c.isWinner">Winner!</span>
                  </template>
                  <a
                    v-else
                    href="#"
                    @click.prevent="makeWinner(c.id)"
                  >Make Winner</a>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="submit">
            <a
              href="#"
              class="btn-default"
              @click.prevent="goBack"
            >Back to Draws</a>
          </div>
        </div>

      </div>
    </div>
  </tab-layout>
</template>

<script>
import { defineComponent, ref, computed, getCurrentInstance, onMounted } from '@vue/composition-api'
import TabLayout from '@/components/TabLayout'
import useDrawsResult from '@/composables/draws/useDrawsResult'
import drawsApi from '@/services/api/draws'

export default defineComponent({
  name: 'DrawsResult',
  components: { TabLayout },
  setup() {
    const vm = getCurrentInstance()
    const route = vm.proxy.$route
    const router = vm.proxy.$router
    const eventId = computed(() => route.params.eventId)
    const round = computed(() => route.params.round)

    const judge = ref('')
    const eventName = ref('')
    const rounds = ref([])

    const {
      results,
      topCutout,
      hasWinner,
      loading,
      fetchResults,
      setWinner
    } = useDrawsResult(eventId.value)

    const activeRoundLabel = computed(() => {
      const r = parseInt(round.value, 10)
      const totalRounds = rounds.value.length
      if (r === totalRounds) {
        return 'final round'
      }
      const found = rounds.value.find(item => item.id === r)
      return found != null ? found.label : ''
    })

    function goBack() {
      router.back()
    }

    async function makeWinner(drawId) {
      await setWinner(drawId)
      await fetchResults(round.value)
    }

    onMounted(async () => {
      try {
        const res = await drawsApi.getEventMeta(eventId.value)
        const data = res.data.data
        const draft = data.draft != null ? data.draft : {}
        eventName.value = draft.eventName != null ? draft.eventName : ''
        judge.value = draft.judgeName != null ? draft.judgeName : ''
        rounds.value = data.rounds != null ? data.rounds : []
      } catch (_) { /* ignore */ }
      await fetchResults(round.value)
    })

    return {
      eventId,
      round,
      activeRoundLabel,
      judge,
      eventName,
      rounds,
      results,
      topCutout,
      hasWinner,
      loading,
      goBack,
      makeWinner
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/views/Draws/Results/DrawsResult.vue